module.exports = __webpack_public_path__ + "img/2017_cdo.85d7f8fa.jpg";